import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { connect } from 'react-redux';
import { Modal, Button, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import ValidatableFormGroup from '../../components/common/ValidatableFormGroup';
import DateTime from 'react-datetime';
import { assign } from '../../shared/Assign';
import moment from 'moment';

interface IProps {
    onApprove(value: boolean, result?: any): () => null;
    onClose(): () => null;
    onBookDirectly(): () => null;
    continueBooking(): () => null;
    preferredTimeOfPhotographing: any;
    showNotes?: boolean;
    notes: string;
}

interface IState {
    errors: any;
    placeholderText: string;
    components: {
        notes: string;
        preferredTimeOfPhotographing: any;
    };
}

class PreferedDateModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            errors: [],
            placeholderText: '',
            components: {
                preferredTimeOfPhotographing: Date,
                notes: ''
            }
        };

        this.onPreferredTimeOfPhotographingDateChange =
            this.onPreferredTimeOfPhotographingDateChange.bind(this);
        this.onNotesChange = this.onNotesChange.bind(this);
    }

    componentDidMount(): void {
        let components = assign({}, this.state.components);
        components.notes = this.props.notes;

        if (this.props.preferredTimeOfPhotographing) {
            components.preferredTimeOfPhotographing = moment(
                this.props.preferredTimeOfPhotographing
            )
                .startOf('hour')
                .add(1, 'hour');
        }

        this.setState({
            placeholderText: Translate(
                'orders/create/modal/preferred-time-of-photographing/preferred-time-placeholder-text'
            )
        });
        this.setState({ components: components });
    }

    save() {
        let components = assign({}, this.state.components);

        const result = [
            {
                name: 'notes',
                value: components.notes
            },
            {
                name: 'preferredTimeOfPhotographing',
                value: components.preferredTimeOfPhotographing
            }
        ];

        this.props.onApprove(false, result);
    }

    onPreferredTimeOfPhotographingDateChange(date: any) {
        let components = assign({}, this.state.components);
        let value = date;

        if (date.target) {
            value = moment(date.target.value);
        }
        components.preferredTimeOfPhotographing = value ? value.toDate() : null;
        this.setState({ components: components });
    }

    onNotesChange(e: any) {
        let components = assign({}, this.state.components);

        components.notes = e.target.value;
        this.setState({ components: components });
    }

    render(): any {
        return (
            <Modal show={true} onHide={this.props.onClose} dialogClassName="modal-ms">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {Translate('orders/create/modal/preferred-time-of-photographing/title')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ValidatableFormGroup
                        validationKey="other.PreferredTimeOfPhotographing"
                        errors={this.state.errors}
                    >
                        <p>
                            {Translate(
                                'orders/create/modal/preferred-time-of-photographing/text-description'
                            )}
                        </p>
                        <DateTime
                            className="desktop-datetime"
                            locale={moment.locale()}
                            isValidDate={(current) => {
                                return current.isAfter(moment().add(-1, 'day'));
                            }}
                            timeFormat={false}
                            value={this.state.components.preferredTimeOfPhotographing}
                            onChange={this.onPreferredTimeOfPhotographingDateChange}
                            inputProps={{
                                name: 'other.PreferredTimeOfPhotographing',
                                autoComplete: 'do-not-autocomplete',
                                placeholder: this.state.placeholderText
                            }}
                        />
                        {this.props.showNotes && (
                            <FormGroup style={{ marginTop: 25 }}>
                                <ControlLabel>
                                    {Translate(
                                        'orders/create/modal/preferred-time-of-photographing/notes'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    componentClass="textarea"
                                    name="title"
                                    value={
                                        this.state.components.notes
                                            ? this.state.components.notes
                                            : ''
                                    }
                                    onChange={this.onNotesChange}
                                />
                            </FormGroup>
                        )}
                    </ValidatableFormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onBookDirectly} className="left" bsStyle="info">
                        {Translate(
                            'orders/create/modal/preferred-time-of-photographing/book-directly'
                        )}
                    </Button>
                    <Button
                        onClick={() => {
                            this.save();
                        }}
                        bsStyle="success"
                    >
                        {Translate(
                            'orders/create/modal/preferred-time-of-photographing/let-se360-book'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {};
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {}
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferedDateModal);
